module.exports = __webpack_public_path__ + "img/small.733eec4c.png";